module.exports = __webpack_public_path__ + "img/Verbandführer_I.4938b1a4.svg";